import { Typography } from "@illimity/web/ui";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PasswordResetScreen } from "../types";
import IdentityResetPswScreen from "./resetPswFlowScreens/IdentityResetPswScreen";
import ResetTemporaryPasswordScreen from "./resetPswFlowScreens/ResetTemporaryPasswordScreen";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { LoginScreen } from "@delorean/login";
import ResetForgetPasswordScreen from "./resetPswFlowScreens/ResetForgetPasswordScreen";
import { Box, Button, Spinner } from "@orion/ui";
import { LeftLine } from "@orion/icons";
import AuthFailureNotification from "@delorean/login/screens/AuthFailureNotification";
import * as loginRoutes from "../../_shared/routing";
import NotificationScreen, { LocationType } from "@delorean/login/screens/NotificationScreen";
import { useForgetPasswordIdentityForm } from "../hook/useForgetPasswordIdentityForm";
import QRCodeScreen from "@delorean/login/screens/QRCodeScreen";
import { setError, setScreen } from "@delorean/actions/loginActions";
import { calcelResetPswProcedure } from "@delorean/actions/resetPasswordActions";
import { useErrorContext } from "../../_shared/context/ErrorContext";
import { useLocation } from "react-router-dom";
type Props = {};

export default function ResetPasswordScreen({}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screen = useSelector((state: RootStateOrAny) => state.login.screen);
  const loading = useSelector((state: RootStateOrAny) => state.login.loading);
  const { hideError } = useErrorContext();
  const location = useLocation();
 
  /* reset temporary psw scenary: return to /login to continue on SCA screen */
  const handleFailure = () => {
    dispatch(setError(""));
    navigate(loginRoutes.login, { state: { fromResetPassword: true } });
  };

  const goBack = () => {
    if (screen === PasswordResetScreen.RESET_PASSWORD) {
      dispatch(calcelResetPswProcedure());
      return;
    }
    navigate(loginRoutes.login, { state: { fromResetPassword: true } });
    dispatch(setScreen(LoginScreen.DEFAULT));
  };

  useEffect(() => {
    hideError(); // resetta l'errore ogni volta che cambia screen o route
  }, [screen, location.pathname]);

  return (
    <Box
      flex
      column
      alignItems="center"
    >
      {loading ? (
        <Spinner size={"16"} />
      ) : (
        <>
          {(screen == PasswordResetScreen.CREDENTIAL_RESETPASSWORD ||
            screen == PasswordResetScreen.RESET_PASSWORD) && (
            <Box flex alignItems="center" width="full">
              <Button
                role="button"
                variant="ghostPrimary"
                flex
                alignItems="center"
                gap2
                px0
                py2
                style={{ cursor: "pointer", minWidth: 0 }}
                onPress={() => goBack()}
                aria-label={t("login.back")}
              >
                <LeftLine w11 />
                <Typography fontSize="md" lineHeight="md" fontWeight="medium">
                  {t("login.back")}
                </Typography>
              </Button>
            </Box>
          )}
          <Box flex justifyCenter>
            {screen === PasswordResetScreen.RESET_PASSWORD_TEMP ? (
              <ResetTemporaryPasswordScreen />
            ) : screen === PasswordResetScreen.CREDENTIAL_RESETPASSWORD ? (
              <IdentityResetPswScreen />
            ) : screen === PasswordResetScreen.RESET_PASSWORD ? (
              <ResetForgetPasswordScreen />
            ) : screen === PasswordResetScreen.FAILURE_PHY ? (
              <AuthFailureNotification
                btnPrimaryTitle={t("login.backToLandingPage")}
                btnPrimarySubmit={() => handleFailure()}
                title={t("forgetPassword.failureTitle")}
                subtitleOne={t("forgetPassword.failureSubtitle")}
                support
              />
            ) : screen === PasswordResetScreen.GENERIC_FAILURE ? (
              <AuthFailureNotification
                btnPrimaryTitle={t("login.backToLandingPage")}
                btnPrimarySubmit={() => handleFailure()}
                title={t("errors.genericFailureTitle")}
                subtitleOne={t("forgetPassword.failureSubtitle")}
                support
              />
            ) : screen === PasswordResetScreen.APP_NOT_ENROLLED ? (
              <AuthFailureNotification
                btnPrimaryTitle={t("login.backToLandingPage")}
                btnPrimarySubmit={() => handleFailure()}
                title={t("errors.genericFailureTitle")}
                subtitleOne={t("errors.appNotEnrolled.line1")}
                support
              />
            ) : screen === PasswordResetScreen.APP_NOTIFICATION ? (
              <NotificationScreen location={LocationType.RESET_PSW}  />
            ) : screen === PasswordResetScreen.APP_QRCODE ? (
              <QRCodeScreen />
            ) : (
              <Navigate to={loginRoutes.login} state={{ fromResetPassword: true }}/>
            )}
          </Box>
        </>
      )}
    </Box>
  );
}
